import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnDestroy } from '@angular/core';
import { TweenMax, Quint } from 'gsap';
import { FormGroup } from '@angular/forms';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { Auth } from '../../autentication/Auth';
import { AutenticationEventType } from '../../autentication/autentication.event.type';
import { TransactionHistoryEventType } from './transaction-history.event.type';
import { SharedService } from '../../shared/shared.service';

@Component({
	selector: 'app-transaction-history',
	templateUrl: './transaction-history.component.html',
	styleUrls: ['./transaction-history.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransactionHistoryComponent implements OnInit, OnDestroy {

	public btnNext = 'Prosseguir';
	public flowIndex = 0;
	public title = ['Transações'];
	public subtitle = [`Nesta página ficam armazenadas solicitações de transações feitas por você <br/>
	e também aquelas realizadas por outros usuários que passaram por sua aprovação ou ainda precisam dela para serem efetivadas.`];
	public form: FormGroup;
	public transactionUser = false;
	public activeBackButton = false;
	public canSend = false;
	public showStepButtons = true;

	constructor(public sharedService: SharedService) {}

	ngOnDestroy() {
		this.removeListeners();
	}

	private removeListeners() {
		AppEventDispatcher.removeListener(TransactionHistoryEventType.BUTTONS);
		AppEventDispatcher.removeListener(TransactionHistoryEventType.BUTTONS_CONFIRM);
		AppEventDispatcher.removeListener(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT_MENU);
		AppEventDispatcher.removeListener(TransactionHistoryEventType.HISTORY.BEGIN);
	}

	ngOnInit() {
		if (Auth.getInstance().getUser().rule === 'TRANSACIONAR') {
			this.transactionUser = true;
		}

		AppEventDispatcher.listen(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT_MENU, () => {

			if (Auth.getInstance().getUser().rule === 'TRANSACIONAR') {
				this.transactionUser = true;
			}

		});

		TweenMax.delayedCall(.3, () => {
			this.show();
		});

		AppEventDispatcher.listen(TransactionHistoryEventType.BUTTONS, data => {
			TweenMax.to('.buttons', .8, {bottom: '-100px', ease: Quint.easeOut});

			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;
				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});
		});

		AppEventDispatcher.listen(TransactionHistoryEventType.BUTTONS_CONFIRM, data => {
			this.btnNext = 'Confirmar';
		});

		AppEventDispatcher.listen(TransactionHistoryEventType.HISTORY.BEGIN, data => {
			this.show();
		});
	}

	onCanSend(event) {
		this.canSend = event;
	}

	show() {
		AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.TRANSACT, { show: true });
	}

	sendForm() {
		AppEventDispatcher.dispatch(TransactionHistoryEventType.TRANSACTION_HISTORY_SEND, null);
	}

	public onSetForm(form: FormGroup) {
		this.form = form;
	}

	public onShowStepButtons(value: boolean) {
		this.showStepButtons = value;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transaction-history/transaction-history.component.ts